import React from 'react';
import { useSelector } from 'react-redux';
import DeviceMap from 'components/features/DeviceView/DeviceMap/DeviceMap';
import DeviceAlarms from 'components/features/DeviceView/DeviceAlarms/DeviceAlarms';
import DeviceTable from 'components/features/DeviceView/DeviceTable/DeviceTable';
import { MapListViewSwitchStates } from 'redux/reducers';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';
import styles from './MapListView.module.css';

function MapListView({ onSelectDeviceGroup }) {
  const mapListSwitch = useSelector((state) => {
    const {
      ui: { devicesPage }
    } = state;

    switch (devicesPage.activeTab) {
      case DEVICES_PAGE_TAB.pivot:
        return devicesPage.pivotTab.mapListViewSwitchState;
      case DEVICES_PAGE_TAB.echo:
        return devicesPage.echoTab.mapListViewSwitchState;
      case DEVICES_PAGE_TAB.all:
      default:
        return devicesPage.allDevicesTab.mapListViewSwitchState;
    }
  });
  const devices = useSelector((state) => {
    const {
      ui: { devicesPage },
      data
    } = state;

    switch (devicesPage.activeTab) {
      case DEVICES_PAGE_TAB.pivot:
        return data.pivotDeviceSets?.deviceTable?.devices;
      case DEVICES_PAGE_TAB.echo:
        return data.echoDeviceSets?.deviceTable?.devices;
      case DEVICES_PAGE_TAB.all:
      default:
        return data.allDeviceSets?.deviceTable?.devices;
    }
  });

  switch (mapListSwitch) {
    case MapListViewSwitchStates.SPLIT:
      return (
        <div className={styles.MapListContainer}>
          <div className={styles.ListContent}>
            <DeviceTable onSelectDeviceGroup={onSelectDeviceGroup} />
          </div>
          <div className={styles.MapContent}>
            <DeviceMap />
          </div>
        </div>
      );
    case MapListViewSwitchStates.LIST:
      return (
        <div className={styles.MapListContainer}>
          <div className={styles.MapListContent}>
            <DeviceTable onSelectDeviceGroup={onSelectDeviceGroup} />
          </div>
        </div>
      );
    case MapListViewSwitchStates.GRID:
      return (
        <div className={styles.MapListContainer}>
          <div className={styles.MapListContent}>
            <DeviceAlarms devices={devices} />
          </div>
        </div>
      );
    default:
      return (
        <div className={styles.MapListContainer}>
          <div className={styles.MapListContent}>
            <DeviceTable devices={devices} onSelectDeviceGroup={onSelectDeviceGroup} />
          </div>
          <div className={styles.MapListContent}>
            <DeviceMap />
          </div>
        </div>
      );
  }
}

export default MapListView;
